class VrHoneyHighlight extends HTMLElement {
  connectedCallback() {
    this.titles = Array.from(this.querySelectorAll('[data-vr-honey-title]'));
    this.media = Array.from(this.querySelectorAll('[data-vr-honey-media]'));

    this.titles.forEach((title) => {
      const index = Number(title.dataset.index);
      title.addEventListener('click', (event) => {
        event.preventDefault();
        this.setActive(index);
      });
      title.addEventListener('mouseenter', () => this.setActive(index));
      title.addEventListener('focus', () => this.setActive(index));
    });

    if (this.titles.length) {
      this.setActive(Number(this.titles[0].dataset.index));
    }
  }

  setActive(index) {
    if (this.activeIndex === index) return;
    this.activeIndex = index;

    this.titles.forEach((title) => {
      const isActive = Number(title.dataset.index) === index;
      title.classList.toggle('is-active', isActive);
      title.setAttribute('aria-selected', isActive);
    });

    this.media.forEach((media) => {
      const isActive = Number(media.dataset.index) === index;
      media.classList.toggle('is-active', isActive);

      const video = media.querySelector('video');
      if (video) {
        if (isActive) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
    });
  }
}

if (!customElements.get('vr-honey-highlight')) {
  customElements.define('vr-honey-highlight', VrHoneyHighlight);
}
